export default "__VITE_ASSET__C1o$y2uw__"